import * as H from "history";
import React, {Component} from "react";
import {MessageBarType} from "office-ui-fabric-react";
import { connect } from "react-redux";
import Actions from "../../redux/Actions";
import { IRootState } from "../../store";
import DispatchProps from "../../utils/DispatchProps";
import ApiService from "../ApiService";
import { DurableFunctionInstance } from "../../models/DurableFunctionInstance";
import {SdsInfo} from "../../models/SdsInfo";
import MailroomSchoolsTable, {MailroomSchoolsTableRow} from "./MailroomSchoolsTable";
import LoadingCard from "../LoadingCard";

export interface MailroomSchoolProps {
    schoolCode: string;
    tenantId: string;

    apiService: ApiService;
    history: H.History;
    
    title?: string;
    
    enableLinkToSchool?: boolean;
    children?: any;
}

export interface MailroomSchoolState {
    dataForSchool?: MailroomSchoolsTableRow | null
}

class MailroomSchool extends Component<MailroomSchoolProps & DispatchProps, MailroomSchoolState> {

    constructor(props: MailroomSchoolProps & DispatchProps) {
        super(props);

        this.state = {};
    }

    public async componentDidMount() {
        if (this.props.tenantId && this.props.schoolCode) {
            await this.load();
        }
    }

    async componentDidUpdate(prevProps: Readonly<MailroomSchoolProps & DispatchProps>, prevState: Readonly<MailroomSchoolState>, snapshot?: any): Promise<void> {
        if (this.props.tenantId !== prevProps.tenantId || this.props.schoolCode !== prevProps.schoolCode) {
            await this.load();
        }
    }

    private async load() {
        try {
            
            const school = await this.props.apiService.getSchoolAdmin(this.props.tenantId,this.props.schoolCode);
            const latestInboxUpload = await this.props.apiService.getLatestDataUploadDateForSchool(this.props.tenantId,this.props.schoolCode);
            const mailroomSchoolConfig = await this.props.apiService.getMailroomSchoolConfig(this.props.tenantId,this.props.schoolCode);
            
            let sdsInfo: SdsInfo | undefined;
            let automationLoopInstance: DurableFunctionInstance | undefined;
            if(mailroomSchoolConfig?.sdsProfileId)
            {
                sdsInfo = await this.props.apiService.getSdsInfo(this.props.tenantId,mailroomSchoolConfig.sdsProfileId);
                automationLoopInstance = await this.props.apiService.getAutomation(this.props.tenantId,mailroomSchoolConfig.sdsProfileId);
            }
            
            this.setState({
                dataForSchool: {
                    school: school,
                    lastSdsUpload: sdsInfo?.lastSdsUpload,
                    lastDataUpload: latestInboxUpload.date,
                    misDataServiceType: mailroomSchoolConfig?.misDataServiceType,
                    academicYear: mailroomSchoolConfig?.academicYear,
                    automationLoopInstance: automationLoopInstance === undefined ? null : automationLoopInstance
                }
            });
       
        }
        catch (e) {
            this.setState({dataForSchool: null});
            console.log(e);
            this.props.dispatch(Actions.showMessageBar(`Error loading mailroom school information`, MessageBarType.error));
        }
    }
    
    public render() {
        
        if(this.state.dataForSchool === undefined)
        {
            return <LoadingCard />;
        }
        
        return (
                <MailroomSchoolsTable
                    title={this.props.title}
                    items={this.state.dataForSchool ? [this.state.dataForSchool] : []}
                    virtualize={false}
                    enableLinks={this.props.enableLinkToSchool}>
                    {this.props.children}
                </MailroomSchoolsTable>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { schoolCode: string, tenantId: string, title?: string, enableLinkToSchool?: boolean,children?: any}): MailroomSchoolProps => {
        return {
            schoolCode: ownProps.schoolCode,
            tenantId: ownProps.tenantId,
            apiService: state.auth.apiService,
            history: state.history,
            title: ownProps.title,
            enableLinkToSchool: ownProps.enableLinkToSchool,
            children: ownProps.children
        };
    }
)(MailroomSchool);